export default __webpack_public_path__ + "static/media/ods4.10a66102.svg";